import { isValidEmail } from '../../../../../../utils'

export const isContactPersonMainFieldsFilled = (email?: string, firstName?: string, lastName?: string): boolean => {
  return !!(email || firstName || lastName)
}

export const isContactPersonEmailValid = (email?: string): boolean => {
  return !email || isValidEmail(email)
}
